import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TreeSelectConfig } from '../../entities/tree-select';
import {HttpService} from '../../services/http/http-service.service';

@Component({
  selector: 'app-s-tree-select',
  templateUrl: './s-tree-select.component.html',
  styleUrls: ['./s-tree-select.component.less']
})
export class STreeSelectComponent implements OnInit {

  @Input() treeSelectConfig: TreeSelectConfig;
  @Output() treeSelectChange: EventEmitter<any> = new EventEmitter();
  style = {
    maxHeight: '150px',
    overflow: 'auto'
  };
  constructor(
    private httpService: HttpService
  ) { }


  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.treeSelectConfig.data = [];
    if (this.treeSelectConfig.url) {
      const parmas = this.treeSelectConfig.params || {};
      this.httpService.httpGet(this.treeSelectConfig.url, parmas).subscribe(res => {
        if (res.code === 1) {
          if (!res.data || !res.data.length) { return; }
          this.initData(res.data);
        }
      });
    }
  }
  initData(data) {
    const func = (tagData) => {
      if (tagData.length > 0) {
        for (let i = 0; i < tagData.length; i++) {
          const { label, value, text, key } = tagData[i];
          Object.defineProperty(tagData[i], 'title', { value: label || text, enumerable: true });
          Object.defineProperty(tagData[i], 'key', { value: value || key, enumerable: true });
          delete tagData[i].label;
          delete tagData[i].value;
          if (tagData[i].children && tagData[i].children.length > 0) {
            func(tagData[i].children);
          } else if (!tagData[i].children || tagData[i].children.length === 0) {
            Object.defineProperty(tagData[i], 'isLeaf', { value: true, enumerable: true });
          }
        }
      }
    };
    func(data);
    this.treeSelectConfig.data = data;
  }

  onChange(e) {
    this.treeSelectConfig.value = e;
    this.treeSelectChange.emit({value: e});
  }

}
